export default __webpack_public_path__ + "static/media/bilhete.c54fbb90.svg";